export default __webpack_public_path__ + "static/media/dark-brain.494e02a2.png";